export default class OnlinePageController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlinePage/list', 'post', params, axiosOption, httpOption);
  }

  static listAllPageAndForm (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlinePage/listAllPageAndForm', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlinePage/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/online/onlinePage/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlinePage/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlinePage/update', 'post', params, axiosOption, httpOption);
  }

  static updatePublished (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlinePage/updatePublished', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlinePage/delete', 'post', params, axiosOption, httpOption);
  }
  static listOnlinePageDatasource (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlinePage/listOnlinePageDatasource', 'post', params, axiosOption, httpOption);
  }

}
